<template>
  <v-card
    :disabled="loading"
    :loading="loading"
    class="AssignmentRunningTestCard"
  >
    <v-toolbar>
      <v-toolbar-title class="font-weight-bold">Question {{ currentTaskNumber }}</v-toolbar-title>
      <v-spacer />
      <v-pagination
        ref="tasksPagination"
        v-model="currentTaskNumber"
        :length="tasks.length"
        :total-visible="11"
        class="ml-4"
        @input="onTasksPaginationInput"
      />
    </v-toolbar>

    <template v-for="task in tasks">
      <AssignmentTask
        v-show="task === currentTask"
        :key="task._id"
        :task="task"
        :answer.sync="answers[task._id]"
        @update:answer="onAnswerUpdate"
        @image-preview="openImagePreview"
      />
    </template>

    <v-card-actions>
      <v-spacer />
      <v-btn
        :disabled="isFirstCurrentTask"
        outlined
        width="150"
        class="mr-6"
        @click="prevTask"
      >
        <v-icon left>keyboard_double_arrow_left</v-icon>
        Previous
      </v-btn>
      <v-btn
        v-if="isLastCurrentTask"
        :disabled="!validAnswers"
        width="150"
        color="primary"
        class="white--text ml-6"
        @click="completeTest"
      >
        Complete
        <v-icon right>check</v-icon>
      </v-btn>
      <v-btn
        v-else
        :disabled="isLastCurrentTask"
        outlined
        width="150"
        class="ml-6"
        @click="nextTask"
      >
        Next
        <v-icon right>keyboard_double_arrow_right</v-icon>
      </v-btn>
      <v-spacer />
    </v-card-actions>

    <PreviewImageDialog
      v-model="imagePreview.active"
      title="Preview image"
      :src="imagePreview.src"
    />
  </v-card>
</template>

<script>
export default {
  name: 'AssignmentRunningTestCard',
  components: {
    AssignmentTask: () => import('@/components/assignments/AssignmentTask'),
    PreviewImageDialog: () => import('@/components/modals/PreviewImageDialog'),
  },
  props: {
    assignmentTest: {
      type: Object,
      default: () => ({}),
    },
    answers: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentTaskNumber: 1,
      imagePreview: {
        active: false,
        src: null,
      },
    };
  },
  computed: {
    tasks() {
      return this.assignmentTest.tasks;
    },
    currentTask() {
      return this.tasks[this.currentTaskNumber - 1];
    },
    isFirstCurrentTask() {
      return this.currentTaskNumber === 1;
    },
    isLastCurrentTask() {
      return this.currentTaskNumber === this.tasks.length;
    },
    validAnswers() {
      const answerEntries = Object.entries(this.answers);
      const validEveryAnswer = answerEntries.every(([taskId, answer]) => {
        const task = this.tasks.find(t => t._id === taskId);
        return this.isValidAnswer(task, answer);
      });
      return this.tasks.length === answerEntries.length && validEveryAnswer;
    },
  },
  created() {
    this.initEmptyAnswers();
    this.fillAnsweredPaginationItems();
  },
  methods: {
    initEmptyAnswers() {
      this.tasks.forEach((task) => {
        if (this.answers[task._id]) {
          return;
        }
        this.$set(this.answers, task._id, []);
      });
    },
    isValidAnswer(task, answer) {
      return answer.length;
    },
    prevTask() {
      if (!this.isFirstCurrentTask) {
        this.currentTaskNumber -= 1;
        this.fillAnsweredPaginationItems();
      }
    },
    nextTask() {
      if (!this.isLastCurrentTask) {
        this.currentTaskNumber += 1;
        this.fillAnsweredPaginationItems();
      }
    },
    onAnswerUpdate() {
      this.$emit('update:answers', this.answers);
    },
    completeTest() {
      if (this.validAnswers) {
        this.$emit('finish');
      }
    },
    onTasksPaginationInput() {
      this.fillAnsweredPaginationItems();
    },
    async fillAnsweredPaginationItems() {
      await this.$nextTick();
      const paginationButtons = this.$refs.tasksPagination.$el.querySelectorAll('li > button.v-pagination__item');
      const answerEntries = Object.entries(this.answers);

      paginationButtons.forEach((btn) => {
        const btnNumber = Number(btn.textContent);

        answerEntries.forEach(([taskId, answers]) => {
          const taskIdx = this.tasks.findIndex(task => task._id === taskId);
          const taskNumber = taskIdx + 1;

          if (taskNumber && taskNumber === btnNumber) {
            if (answers[0]) {
              btn.classList.add('green', 'white--text');
            } else {
              btn.classList.remove('green', 'white--text');
            }
          }
        });
      });
    },
    openImagePreview(src) {
      Object.assign(this.imagePreview, { active: true, src });
    },
  },
};
</script>
